export var ALLOW_PREDEFINED_VALUES = ['payment'];
export var VALID_ALLOW = new Set([
    'payment',
    'fullscreen',
    'microphone',
    'camera',
    'web-share'
]);
export var assertsValidAllow = function (allow) {
    if (!VALID_ALLOW.has(allow)) {
        throw new Error("Invalid allow value: \"".concat(allow, "\""));
    }
};
